export default __webpack_public_path__ + "static/media/zabora.45c8f1e0.jpg";